module.exports = __webpack_public_path__ + "/be5b69cd56e85e1fb7f9b035edb6af8f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/assets/api_icons/api_docs_icon.svg
 ** module id = 1544
 ** module chunks = 0
 **/